<template>
  <div ref="editorDOM" class="websiteBook">
    <div class="windowInfoWrap m-main" ref="innerDOM">
      <a-steps progress-dot :current="current" @change="stepChange">
        <a-step v-for="item in steps" :key="item.title" :title="item.title" />
      </a-steps>
      <div
        v-if="current == 0"
        class="chooseDep"
        @click="addIframeEventListener"
      >
        我不知道挂哪科>
      </div>
      <div v-if="current == 0" class="box1">
        <div class="item">
          <!-- <div class="s1">{{ item.inpatientArea }}</div> -->
          <div class="list">
            <a
              v-for="(item2, index2) in depList"
              :key="index2"
              @click="showWeekDoctor(index2)"
              >{{ item2.name }}</a
            >
          </div>
        </div>
      </div>
      <div v-if="current == 1" class="box2">
        <div class="dateBox">
          <div class="tabgs">
            <div
              v-for="(item, index) in weekList"
              :key="index"
              :class="index == currentDateIndex ? 'item now' : 'item'"
              @click="changeDateStyle(index)"
            >
              <div class="date">{{ item.date }}</div>
              <div class="tit1">{{ item.week }}</div>
            </div>
          </div>
        </div>
        <div class="table" v-if="dutyList.length > 0">
          <a-table
            :columns="columnsWeekDoctor"
            :data-source="dutyList"
            :pagination="false"
          >
            <span slot="action" slot-scope="text, record">
              <a slot="action" href="javascript:;" @click="bookInfo(record)">{{
                text > 0 ? '可预约' : '不可预约'
              }}</a>
            </span>
          </a-table>
        </div>
        <div class="noData" v-else>
          暂无排班
        </div>
        <div class="recommend">
          <div class="mainTitle">同专业医生推荐</div>
          <!-- <div class="viewMore">
            <div class="content">
              <router-link
                :to="ComponentDataConfig[5].href"
                :rel="ComponentDataConfig[5].nofollow_href"
                target="_blank"
              >
                <div class="title" ref="titlestyle">
                  {{ ComponentDataConfig[5].txt }}
                </div>
              </router-link>
            </div>
          </div> -->
          <div
            v-if="doctorList.length > (SCREEN.mobile ? 1 : 4)"
            class="mbox1_swiper m-main"
            style="overflow:hidden"
            ref="listbox2"
          >
            <m-swiper v-if="reload" :options="swiperOption" class="swiper">
              <m-swiper-slide v-for="(item, index) in doctorList" :key="index">
                <div @click="chooseDoctor(item)">
                  <router-link>
                    <div class="img1">
                      <img :src="SetImage(item.head)" alt="" title="" />
                    </div>
                    <div class="text">
                      <div class="tit" ref="titlestyle">{{ item.name }}</div>
                      <div class="tit1" ref="titlestyle1">
                        {{ item.hisDeptName }} <br />
                        {{ item.title }}
                      </div>
                      <!-- <div class="desc" ref="titlestyle2">
                        {{ item.textarea }}
                      </div> -->
                    </div>
                  </router-link>
                </div>
              </m-swiper-slide>
            </m-swiper>
            <div class="button">
              <div class="swiper-button-prev03"></div>
              <div class="swiper-button-next03"></div>
            </div>
          </div>

          <div v-else-if="doctorList.length != 0" class="mbox1 m-main">
            <div
              v-for="(item, index) in doctorList"
              :key="index"
              class="item"
              @click="chooseDoctor(item)"
            >
              <router-link>
                <div class="img1">
                  <img :src="SetImage(item.head)" alt="" title="" />
                </div>
                <div class="text">
                  <div class="tit" ref="titlestyle">{{ item.name }}</div>
                  <div class="tit1" ref="titlestyle1">
                    {{ item.hisDeptName }} <br />
                    {{ item.title }}
                  </div>
                  <!-- <div class="desc" ref="titlestyle2">
                    {{ item.textarea }}
                  </div> -->
                </div>
              </router-link>
            </div>
          </div>

          <div v-else class="mbox1 m-main">
            暂无同专业医生推荐
          </div>
        </div>
      </div>

      <div v-if="current == 2" class="box3">
        <div class="tip1">
          预约成功后,请您于就诊当天来我院自助取号就诊或凭预约短信直接到相应诊区就诊
        </div>

        <a-form>
          <!-- <a-form-item label="">
            <a-date-picker style="width: 296px" v-decorator="['reserveDate']" />
          </a-form-item> -->
          <div class="top">
            <div class="tit1">选择预约时间段</div>
            <div class="listLable">
              <div class="label">
                <div class="left"></div>
                <div class="right">当前已选</div>
              </div>
              <div class="label">
                <div class="left"></div>
                <div class="right">可选</div>
              </div>
              <div class="label">
                <div class="left"></div>
                <div class="right">不可选</div>
              </div>
            </div>
          </div>

          <div class="listbox">
            <div class="morning" v-if="dutyDoctorDetailList.amList.length > 0">
              <span class="s1">上午</span>
              <a
                v-for="(item, index) in dutyDoctorDetailList.amList"
                :key="index"
                href="javascript:void(0);"
                @click="getCurrentTimeSpan(0, index)"
                :class="index == showAMTime ? 'a1 now' : 'a1'"
                >{{ item.startTime }}-{{ item.endTime }}
              </a>
              <div class="detailSection" v-show="showAMTime != -1">
                <a
                  v-for="(item2, index2) in dutyDoctorDetailList.amList[
                    this.currentTimeSpanIndexAM
                  ].sectionNoList"
                  :key="index2"
                  href="javascript:void(0);"
                  @click="getCurrentSectionNo(0, index2)"
                  :class="
                    index2 == currentSectionNoIndexAM
                      ? 'a2 now'
                      : item2.available == 1
                      ? 'a2 available'
                      : 'a2 unavaliable'
                  "
                  >{{ item2.sectionNo }}</a
                >
              </div>
            </div>
            <div
              class="afternoon"
              v-if="dutyDoctorDetailList.pmList.length > 0"
            >
              <span class="s1">下午</span>
              <a
                v-for="(item, index) in dutyDoctorDetailList.pmList"
                :key="index"
                href="javascript:void(0);"
                @click="getCurrentTimeSpan(1, index)"
                :class="index == showPMTime ? 'a1 now' : 'a1'"
                >{{ item.startTime }}-{{ item.endTime }}
              </a>
              <div class="detailSection" v-show="showPMTime != -1">
                <a
                  v-for="(item2, index2) in dutyDoctorDetailList.pmList[
                    this.currentTimeSpanIndexPM
                  ].sectionNoList"
                  :key="index2"
                  href="javascript:void(0);"
                  @click="getCurrentSectionNo(1, index2)"
                  :class="
                    index2 == currentSectionNoIndexPM
                      ? 'a2 now'
                      : item2.available == 1
                      ? 'a2 available'
                      : 'a2 unavaliable'
                  "
                  >{{ item2.sectionNo }}</a
                >
              </div>
            </div>
          </div>
          <div class="top" style="margin-bottom:30px">
            <div class="tit1" style="margin-top:10px;">选择就诊人</div>
          </div>
          <a-form-item label="">
            <a-select
              style="width: 200px;margin-right:8px"
              v-decorator="['hisPatientName']"
              :value="hisPatientId"
              @change="handleSelectChangehisPatientNameList"
            >
              <a-select-option
                :value="items.hisId"
                v-for="(items, index) in hisPatientNameList"
                :key="index"
              >
                {{ items.name }}
              </a-select-option>
            </a-select>
            <a
              id="tjjzr"
              href="javascript:void(0);"
              datanum="1"
              style="background: #0078d4;font-size: 16px;border-radius: 200px;text-align: center;display: inline-block;padding: 0 15px;height:32px;line-height:32px;margin-top:5px;color:white;"
              @click="addNewPatient()"
              >添加新的就诊人</a
            >
          </a-form-item>
          <!-- <AddPersonAgreement v-if="mic.showCurProtocol" v-model="agreeCheck" :michref="mic.curMic.micUrl" hospital="cd"/> -->
          <AddPersonAgreement v-model="agreeCheck" :michref="mic.latestMic.micUrl" hospital="cd"/>
        </a-form>
        <div class="confirmBtn">
          <a href="javascript:;" id="tj_button" class="-dis" @click="handleSubmit">
            <i>确认预约</i>
          </a>
        </div>
        <div class="guahao3page1_alert" v-if="confirm">
          <a href="javascript:;" class="close" @click="closePop"></a>
          <div class="inner">
            <div class="tit2">添加新的就诊人</div>
            <a-form
              :label-col="{ span: 6 }"
              :wrapper-col="{ span: 13 }"
              :form="formAddPatient"
            >
              <a-form-item label="姓名：" prop="name">
                <a-input v-model="consultantForm.name" />
              </a-form-item>
              <a-form-item label="证件类型：">
                <a-select
                  @change="handleSelectChange"
                  v-model="consultantForm.idType"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in zjTypeList"
                    :key="index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="证件号码：">
                <a-input @keyup="enterIdNo" v-model="consultantForm.idNo" :maxLength="30" />
              </a-form-item>
              <a-form-item label="性别：">
                <a-select v-model="consultantForm.gender">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in genderList"
                    :key="index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="出生日期：">
                <a-date-picker
                  style="width:100%"
                  v-model="consultantForm.birthday"
                  valueFormat="YYYY-MM-DD"
                  :format="dateFormat"
                  placeholder="请选择"
                  :disabled-date="pickerOptions"
                  :disabled="consultantForm.idType == '01'"
                />
              </a-form-item>
              <a-form-item label="民族：">
                <a-select v-model="consultantForm.nation">
                  <a-select-option
                    :value="item.code"
                    v-for="(item, index) in nationList"
                    :key="index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="手机号码：">
                <a-input v-model="consultantForm.phone" />
              </a-form-item>
              <a-form-item label="验证码：">
                <a-input-search
                  v-model="consultantForm.verifyCode"
                  :enter-button="
                    codeTimer ? codeSecond + 's后获取' : '获取验证码'
                  "
                  @search="getVerifyCode"
                />
                <!-- size="small" -->
              </a-form-item>
              <a-form-item label="与本人关系：">
                <a-select v-model="consultantForm.relation">
                  <a-select-option
                    :value="item.id"
                    v-for="(item, index) in relationshipList"
                    :key="index"
                  >
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="现地址：">
                <a-cascader v-model="consultantForm.region" :options="province" placeholder="请选择省市县" />
              </a-form-item>
              <a-form-item label="详细地址：">
                <a-input v-model="consultantForm.address" />
              </a-form-item>
              <br/>
              <AddPersonAgreement v-model="consultantForm.agreeCheck" :section="true" :sectiontips="true" :showpersonal="false" hospital="cd" />
              <AddPersonAgreement v-model="consultantForm.agree360Check" :showtips="false" :michref="mic.latestMic.micUrl" hospital="cd" />
            </a-form>

            <div class="guahao3page1-button" html-type="submit">
              <a
                id="patientAdd"
                href="javascript:void(0);"
                @click="handleConsultantOk()"
              >
                <i>确认添加</i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="current == 3" class="box4">
        <div v-if="ifSuccess == true" class="boxSuccess">
          <div class="statebox">
            <div class="tit">
              预约成功
            </div>
            <div class="btnSearch">
              <router-link
                class="btn2_book"
                to="/personalCenter/personalList#4"
              >
                <span>
                  预约记录查询
                </span></router-link
              >
              <!-- <router-link
                class="btn2_pay"
                :to="ComponentDataConfig.href_2"
                :rel="ComponentDataConfig.nofollow_href_2"
              >
                <span>
                  去支付
                </span></router-link
              > -->
              <a
                class="btn2_pay"
                @click="SCREEN.mobile ? goPaymentPhone() : goPayment()"
              >
                <span>
                  去支付
                </span></a
              >
            </div>
          </div>

          <div class="box2box">
            <div class="boxitem">
              <div class="tit1">个人基本信息</div>
              <div class="textlist clear">
                <div class="item1">
                  姓名：{{ websiteBookList.hisPatientName }}
                </div>
                <div class="item1">证件号：{{ idNoHide }}</div>
                <div class="item1">手机号码：{{ phone }}</div>
              </div>
            </div>
            <div class="boxitem">
              <div class="tit1">网上预约信息</div>
              <div class="textlist clear">
                <div class="item1">诊疗卡号：{{ websiteBookList.cardNo }}</div>
                <div class="item1">科室：{{ websiteBookList.hisDeptName }}</div>
                <div class="item1">
                  医生：{{ websiteBookList.hisDoctorName }}
                </div>
                <!-- <div class="item1">挂号类型：专家门诊（副主任）</div> -->
                <div class="item1">
                  就诊时间：{{ websiteBookList.orderTime }}
                </div>
              </div>
            </div>
            <div class="boxitem">
              <div class="tit1">提示信息</div>
              <div class="textlist clear">
                <div class="item">
                  预约成功后,请您于就诊当天来我院自助取号就诊或凭预约短信直接到相应诊区就诊。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="ifSuccess == false" class="boxFail">
          <div class="statebox" id="hbg">
            <div class="tit">{{ erroeMsg }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask50" v-if="showLoginMask == true"></div>
    <div class="contactfixed" v-if="showLoginMask == true">
      <h1>请登录</h1>
      <div class="btn">
        <!-- <router-link
          :to="ComponentDataConfig.href_3"
          :rel="ComponentDataConfig.nofollow_href_3"
        >
          确定
        </router-link> -->
        <a @click="goLogin">确定</a>
      </div>
    </div>

    <!-- iframe 不知道挂哪科-->
    <div v-if="showIframe">
      <div class="wemsk"></div>
      <div class="noIdea">
        <div class="noIdeaClose" @click="closeNoIdeaModal">X</div>
        <div class="iframe-box">
          <iframe
            width="100%"
            height="100%"
            :src="iframeSrc"
            frameborder="0"
          ></iframe>
        </div>
      </div>
    </div>

    <!-- 支付弹框 -->
    <div v-show="paymentVisible">
      <div class="wemsk"></div>
      <div class="pay-model-box">
        <div class="pay-main-box">
          <div class="title">
            <div class="top-title">
              挂号成功<span class="close-span" @click="closePaymentModal"
                >x</span
              >
            </div>
            <div class="two-box">
              您预约的{{
                paymentRecord.hisDeptName +
                  paymentRecord.hisDoctorName +
                  '医生'
              }}<span>{{ paymentRecord.orderTime }}</span
              >挂号成功
            </div>
            <div class="three-box">
              请于<span>30分钟</span>内完成支付，如在有效期内未完成支付，将自动为您取消预约
            </div>
          </div>
          <div class="pay-money">
            应付金额：<span>{{ paymentFee }}</span
            >元
          </div>
          <div class="img-box">
            <div class="left-img-box">
              <div class="qrcode-out-box">
                <div id="qrcode" class="qrcode-box"></div>
              </div>
              <div class="bottom-remind-box">
                <img class="img" src="../images/sm.png" alt="" />
                <div class="txt">请使用微信、支付宝<br />扫码支付</div>
              </div>
            </div>
            <div class="right-img-box">
              <img src="../images/payBg.png" alt="" />
            </div>
          </div>
          <div class="red-txt-box">
            <div class="content-red-box">
              <img src="../images/gth.png" alt="" />
              距离二维码过期还剩<span>{{ num }}</span
              >秒，过期后请重新获取二维码
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 支付成功弹框 -->
    <div v-if="paySuccessVisible">
      <div class="wemsk"></div>
      <div class="pay-success-model-box">
        <div class="top-title">
          支付成功<span class="close-span" @click="closePaySuccessModal"
            >x</span
          >
        </div>
        <div class="middle-box">
          <img src="../images/success.png" alt="" />
          您已成功付款<span>{{ paymentFee }}</span
          >元
        </div>
        <div class="bottom-box">
          <span>{{ paySuccessNum }}</span
          >s后自动关闭
        </div>
      </div>
    </div>

    <!-- 手机支付中弹框 -->
    <div v-if="payPhoneVisible">
      <div class="wemsk"></div>
      <div class="pay-success-model-box">
        <div class="top-title">
          支付中<span class="close-span" @click="closePayPhoneModal">x</span>
        </div>
        <div class="middle-box">
          <!-- <img src="../images/success.png" alt=""> -->
          请于30分钟内完成支付，如在有效期内未完成支付，将自动为您取消预约
        </div>
        <div class="bottom-box">
          <span>{{ num }}</span
          >s后自动关闭，请重新获取支付链接
        </div>
      </div>
    </div>

    <!-- 是否支付完成弹窗begin -->
    <div v-if="showHasPaySuccess">
      <div class="wemsk"></div>
      <div class="has-pay-success">
        <div class="gth-box">
          <div class="gth">
            !
          </div>
        </div>
        <div class="txt">请确认是否支付完成</div>
        <div class="btn-box">
          <p @click="refreshPay">重新支付</p>
          <p class="red-btn" @click="hasPaySuccess">已完成支付</p>
        </div>
      </div>
    </div>
    <!-- 是否支付完成弹窗end -->
  </div>
</template>

<script>
import { JSEncrypt } from 'jsencrypt'
import { MIC_CONFIG } from "@/utils/constant";
import{ checkIdNo, checkPhoneNo, checkIdTypes } from '@/utils/index';
import AddPersonAgreement from "@/components/hospitalPersonalList/addPersonAgreement"

export default {
  name: 'hospital-websitebook-001',
  components: {
    AddPersonAgreement,
  },
  data() {
    return Object.assign({
      steps: [
        { title: '选择科室' },
        { title: '选择医生' },
        { title: '选择信息' },
        { title: '预约成功' },
      ],
      ifSuccess: true,
      erroeMsg: '',
      hisPatientId: '',
      agreeCheck: false, // 预约挂号-勾选协议
      current: 0,
      depList: [
        // {
        //   inpatientArea: "内科综合病区",
        //   list: [
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" }
        //   ]
        // },
        // {
        //   inpatientArea: "内科综合病区",
        //   list: [
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" }
        //   ]
        // },
        // {
        //   inpatientArea: "内科综合病区",
        //   list: [
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" },
        //     { department: "呼吸内科门诊", hisId: "" }
        //   ]
        // }
      ],
      weekList: [],
      currentDateIndex: 0,
      columnsWeekDoctor: [
        {
          title: '医生',
          dataIndex: 'hisDoctorName',
          key: 'hisDoctorName',
        },
        {
          title: '挂号类型',
          dataIndex: 'dutyType',
          key: 'dutyType',
        },
        {
          title: '状态',
          dataIndex: 'available',
          key: 'available',
          scopedSlots: {
            customRender: 'action',
          },
        },
      ],
      dutyList: [
        // {
        //   hisDeptId: "3035",
        //   hisDeptName: "眼科门诊",
        //   hisDoctorId: "80013",
        //   hisDoctorName: "董力群",
        //   doctorId: 458,
        //   head:
        //     "http://tupian.baike.com/ipad/a0_78_52_01200000123847134434529793168_jpg.html",
        //   title: "主任医师",
        //   fee: "10",
        //   total: 6,
        //   available: 5,
        //   introduceUrl: "static/H02/doctor456.html",
        //   dutyTypeCode: 1,
        //   dutyType: "普通挂号"
        // },
        // {
        //   hisDeptId: "3035",
        //   hisDeptName: "眼科门诊",
        //   hisDoctorId: "80001",
        //   hisDoctorName: "严志诚",
        //   doctorId: 457,
        //   head:
        //     "http://tupian.baike.com/ipad/a0_78_52_01200000123847134434529793168_jpg.html",
        //   title: "主任医师",
        //   fee: "10",
        //   total: 5,
        //   available: 5,
        //   introduceUrl: "static/H02/doctor456.html",
        //   dutyTypeCode: 1,
        //   dutyType: "普通挂号"
        // }
      ], //科室下排班医生列表返回
      confirm: false, //是否弹出添加就诊人对话框标志
      hisPatientNameList: [], //就诊人列表
      // hisDeptId:"M006",
      hisDeptId: this.$route.query.hisDeptId || '',
      hisDoctorId: this.$route.query.hisDoctorId || '',
      dutyDate: this.$route.query.dutyDate || '',
      dutyDoctorDetailList:{amList:[],pmList:[]},
      websiteBookList: {}, //确认预约返回结果
      formAddPatient: this.$form.createForm(this, { name: 'formAddPatient' }), //添加就诊人
      dateFormat: 'YYYY-MM-DD',
      dutyId: '',
      sectionNo: '',
      currentSectionNoIndexAM: 0, //当前序号
      currentTimeSpanIndexAM: 0, //当前时间段
      currentSectionNoIndexPM: 0, //当前序号
      currentTimeSpanIndexPM: 0, //当前时间段
      showAMTime: 0,
      showPMTime: 0,
      currentTimeSpanIndex: 0,
      currentSectionNoIndex: 0,
      orderTime: '',
      // zjTypeList: [
      //   {
      //     id: "01",
      //     name: "居民身份证"
      //   },
      //   {
      //     id: "03",
      //     name: "护照"
      //   },
      //   {
      //     id: "06",
      //     name: "港澳居民来往内地通行证"
      //   },
      //   {
      //     id: "07",
      //     name: "台湾居民来往内地通行证"
      //   }
      // ],
      zjTypeList: [
        { id: '01', name: '居民身份证' },
        { id: '02', name: '户口簿' },
        { id: '07', name: '护照' },
        { id: '08', name: '港澳居民来往内地通行证' },
        { id: '10', name: '台湾居民来往大陆通行证' },
        // { id: '12', name: '港澳台湾居民居住证' },
        { id: '15', name: '外国人永久居留身份证' },
      ],
      genderList: [
        {
          name: '男',
          id: '1',
        },
        {
          name: '女',
          id: '2',
        },
      ],
      relationshipList: [
        {
          id: '0',
          name: '本人',
        },
        {
          id: '1',
          name: '子女',
        },
        {
          id: '2',
          name: '父母',
        },
        {
          id: '3',
          name: '夫妻',
        },
        {
          id: '4',
          name: '其它',
        },
      ],
      consultantForm: {
        sys: 'ohealth',
        hospitalCode: 'H05',
        name: '',
        phone: '',
        idType: '01',
        idNo: '',
        birthday: '',
        gender: '1',
        relation: '0',
        verifyCode: '',
        source: 'web',
        nation: '01',
        agreeCheck: false, // 确认添加就诊人-勾选协议
        agree360Check: false,
        region: [],
        address: '',
      },
      publicKey: '',
      patientDeatiDataPhone: '',
      idNo: '',
      idNoHide: '',
      phone:'',
      showIframe: false,
      // iframeSrc: "https://ssctest.boe.com/html/boeHospital/aiTriage", // 测试地址
      iframeSrc: 'https://ssc.boe.com/html/boeHospital/aiTriage', // 生产地址
      showLoginMask: false, //未登录弹框,
      orderCode: '',
      fee: '',

      paymentVisible: false, // 显示支付弹框
      paymentQrCode: '', // 二维码显示链接
      paymentRecord: {
        // 支付数据信息
      },
      timer: '', // 定时器
      num: 60, // 二维码展示倒计时时长

      paySuccessTimer: '', // 支付成功计时器
      paySuccessNum: 5, // 支付成功展示时间
      paySuccessVisible: false, // 显示支付成功

      paymentFee: '', // 支付金额

      payPhoneVisible: false, // 手机支付弹框显示
      hospitalCode: 'H05',

      showHasPaySuccess: false, // 手机支付中弹框

      paymentLock: true, // 手机支付锁，防止多次点击去支付

      codeTimer: null,
      codeSecond: 120,
      sex: '',
      womandeptArr:['M038','M089','M094',], // 女性科室数组
      mandeptArr:['M063',], // 男性科室数组
      // 同专业医生推荐列表
      // doctorList: [{
      //   img: "https://dhwoss.boe.com/jpg/6XOv5mHWAcKtIpEoUjTJ4ePI3t9p5D.jpg",
      //   title: "姓名",
      //   txt: "科室",
      //   txt_1: "职称",
      //   textarea: "医生介绍",
      // },{
      //   img: "https://dhwoss.boe.com/jpg/T5cx6KR5RmCZnl3DXRZuK1OhI9sCYo.jpg",
      //   title: "姓名1",
      //   txt: "科室1",
      //   txt_1: "职称1",
      //   textarea: "医生介绍1",
      // }],  // 同专业医生推荐列表
      doctorList: [],

      swiperOption: {
        grabCursor: true,
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 20,
        coverflowEffect: {
          rotate: 0, //旋转
          stretch: 0, //伸展
          depth: 400, //深度
          modifier: 1, //修饰语
          slideShadows: true,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        initialSlide: 0,
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next03',
          prevEl: '.swiper-button-prev03',
        },
        breakpoints: {
          768: {
            //xiao
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 30,
          },
        },
        // autoplay:false,
        speed: 1500,
      },

      reload: true,

      dutyDoctorIdList: '', // 医生的hisId，用英文逗号隔开，查询同专业医生使用
      firstDoctorDutyDate: '', // 有排班医生的第一个排期

      nationList: [], // 民族选项
      ehealthCardFlag: false, // 标记显示就诊人或电子健康卡 false 显示就诊人列表；true 显示电子健康卡

      // 360健康视图
      mic: {
        latestMic: {}, // 当前在用360协议信息
        curMic: {}, // 当前就诊人360协议签署状态
        showCurProtocol: false, // 预约挂号-默认不展示签署模块
      },
      province: [], // 省市县
    })
  },
  mounted() {
      this.getDeptList()
      this.getCurrentDateWeek7()
    // 医生出诊信息列表过来用这个
    if (this.DeptId != '' && this.hisDoctorId != '' && this.dutyDate != '') {
      this.getRouterDoctorTable()
    } else {
      this.$forceUpdate()
      // this.getPatientList(); //获取就诊人列表,会进行登录判断
    }
    this.getNationList() // 获取民族列表
    this.getPublicKey()

    this.getMicUsing() // 360个人知情同意书-当前再用信息
    this.getProvincesList()
  },
  // beforeRouteEnter(to,from,next){
  //   console.log("beforeRouteEnter enter:", to)
  //   if (process.client){
  //     console.log("router.js ut:",localStorage.getItem('ut'));
  //     console.log("router.js fullPath:",to.fullPath);
  //     if(localStorage.getItem('ut')){ // 判断当前的token是否存在 ； 登录存入的token
  //       next();
  //     }
  //     else{
  //       next({
  //         path: '/personalCenter/login',
  //         query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
  //       })
  //     }
  //   } else {
  //     console.log("beforeRouteEnter enter else:", next)
  //   }
  // },
  methods: {
    //     payQrCode() {
    //   this.$API
    //     .payQrCode({
    //       sys: "H05",
    //       source:"website",
    //       platform:"alipay",
    //       payType:"app",
    //       businessId:"A1",
    //       businessType:" 预约支付",
    //       productId:this.orderCode,
    //       productName:"门诊预约",
    //       totalFee:this.fee,
    //       buyerId:this.hisPatientId,
    //       accessType:"5",
    //     })
    //     .then(res => {
    //     console.log("res",res)
    //     });
    // },

    // 没登录去登录
    pickerOptions(current) {
      return current && (current.valueOf() < new Date('1900', '0', '1').getTime()) || (current.valueOf() > new Date().getTime());
    },
    goLogin() {
      this.$router.push({
        path: '/personalCenter/login',
        query: { redirect: '/medicalCenter/websiteBook' }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    },
    getRouterDoctorTable() {
      this.getDutyDoctorDetail()
      this.getPatientList() // 获取就诊人列表,会进行登录判断
      this.current = 2
    },
    // 步骤选择
    stepChange(current) {
      console.log('onChange:', current)
      if (current > this.current) {
        return
      }
      this.current = current
      if (current == 1) {
        this.currentDateIndex = 0 //日期设为第一个
        this.changeDateStyle(this.currentDateIndex)
        this.dutyId = ''
        this.sectionNo = ''
        this.hisPatientId = ''
      }
      if (current == 2) {
        this.dutyId = ''
        this.sectionNo = ''
        this.hisPatientId = ''
        this.getDutyDoctorDetail()
        this.getPatientList()
      }
    },
    //获取科室列表
    getDeptList() {
      this.$API
        .deptList({
          hospitalCode: this.hospitalCode,
        })
        .then((res) => {
          this.$set(this, 'depList', res.data)
        })
    },
    //current 0 1
    showWeekDoctor(index2) {
      let ut = localStorage.getItem('ut')
      // localStorage中没有ut，判断是否登录
      if (ut == undefined || ut == null || ut == '') {
        this.showLoginMask = true
        return
      }
      this.current = 1
      this.currentDateIndex = 0
      this.getPatientList() //获取就诊人列表,会进行登录判断
      this.getCurrentDateWeek7()
      this.hisDeptId = this.depList[index2].hisId //获取科室
      this.dutyDate = this.weekList[0].date //时间
      this.getDutyList()
    },
    //current 1 点击日期显示医生可否预约
    changeDateStyle(index) {
      console.log('change Date:', this.weekList[index].date)
      this.currentDateIndex = index
      //科室下医生排班列表
      this.dutyDate = this.weekList[index].date
      this.getDutyList()
    },
    //current1 选择医生预约current2
    bookInfo(record) {
      this.hisDoctorId = record.hisDoctorId
      this.hisDeptId = record.hisDeptId
      this.getDutyDoctorDetail()
      this.getPatientList() // 获取就诊人列表,会进行登录判断
      this.current = 2
      // 获取可预约的时间段;
    },
    // 获取民族列表
    getNationList() {
      this.$API.getNationList().then((res) => {
        if (res && res.code == 0) {
          console.log('getNationList res:', res)
          this.nationList = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    async getProvincesList() {
      const arrProvinces = [];
      const par = {};
      const res = await this.$API.getProvincesList(par);
      if (res.code === '0') {
        Object.keys(res.data).forEach((index) => {
          const itemLevel1 = {};
          itemLevel1.value = `${res.data[index].provinceName},${res.data[index].provinceCode}`;
          itemLevel1.label = res.data[index].provinceName;
          itemLevel1.children = [];
          const data = res.data[index].cities;
          let itemLevel2 = {};
          Object.keys(data).forEach((index1) => {
            const data2 = data[index1].counties;
            let itemLevel3 = {};
            itemLevel2.value = `${data[index1].cityName},${data[index1].cityCode}`;
            itemLevel2.label = data[index1].cityName;
            itemLevel2.children = [];
            Object.keys(data2).forEach((index2) => {
              itemLevel3.value = `${data2[index2].countyName},${data2[index2].countyCode}`;
              itemLevel3.label = data2[index2].countyName;
              itemLevel2.children.push(itemLevel3);
              itemLevel3 = {};
            });
            itemLevel1.children.push(itemLevel2);
            itemLevel2 = {};
          });
          arrProvinces.push(itemLevel1);
        });
        this.province = arrProvinces
      }
    },
    // 查询个人知情同意书在用信息
    getMicUsing() {
      const _this = this
      this.$API.getMicUsingSingle({
        hospitalCode: 'H05'
      }).then((res) => {
        if (res.code == 0 && res.data) {
          _this.mic.latestMic = res.data;
        }
      });
    },
    // 请求该用户是否勾选过个人知情同意书
    async queryMicSignStatus() {
      const patientInfo = this.curPatient || {};
      const {hisId, name} = patientInfo;
      const params = {
        hospitalCode: 'H05',
        hisId,
        patientName: name,
      };
      const {code, data, msg} = await this.$API.getMicStatusSingle(params);
      console.log(data, '---签署状态---')
      if(code === '0') {
        let {micVersion, signStatus, validFlag, micUrl, id} = data;
        // ----------------test------------------
        // signStatus = 0
        // ----------------test------------------
        this.mic.curMic = {
          micUrl,
          micVersion,
          id,
          signStatus
        }
        // 如果没有签署过需要签署 signStatus=0 未签署 validFlag=1 协议有效
        if(signStatus === 0) {
          this.agreeCheck = false;
          this.mic.showCurProtocol = true;
        }
        else if (signStatus === 1) {
          this.agreeCheck = true;
          this.mic.showCurProtocol = false;
        }
      } else {
        this.$message.error(msg)
      }
    },
    addNewPatient() {
      this.confirm = true
    },
    // 新增就诊人确定
    async handleConsultantOk() {
      const _this = this
      if (!this.consultantForm.agreeCheck) {
        this.$message.warning('请先阅读并同意相关协议')
        return
      }
      console.log('新增就诊人表单', this.consultantForm)
      if (!this.consultantForm.name) {
        this.$message.error('请输入姓名');
        return false;
      }
      if (this.consultantForm.idType == "01") {
        if (!checkIdNo(this.consultantForm.idNo)) {
          this.$message.error('身份证号格式错误，请检查后输入');
          return false;
        }
      }else if (this.consultantForm.idType == "15") {
        const p = /(^[A-Za-z0-9]{15}|^[A-Za-z0-9]{18})$/;
        if (!p.test(this.consultantForm.idNo)) {
          this.$message.error("证件号格式错误，请输入15或18位证件号");
          return false;
        }
      } else {
        if (!checkIdTypes(this.consultantForm.idNo)) {
          this.$message.error('证件号格式错误，仅支持数字,字母');
          return false;
        }
      }
      if (!checkPhoneNo(this.consultantForm.phone)) {
        this.$message.error('手机号码格式错误，请检查后重新输入');
        return false;
      }
      if (!this.consultantForm.birthday) {
        this.$message.error('请选择出生日期');
        return false;
      }
      if (this.consultantForm.region.length < 1) {
        this.$message.error('请选择地址');
        return false;
      }
      if (!this.consultantForm.address) {
        this.$message.error('请输入详细地址');
        return false;
      }
      const Today = new Date(new Date().toLocaleString().split(" ")[0]).getTime();
      const getBirthday = new Date(this.consultantForm.birthday.replaceAll('-','/')).getTime();
      // 判断当前日期跟出生日期
      if (getBirthday > Today) {
        this.$message.error('出生日期不能晚于当前日期');
        return false;
      }
      this.confirmLoading = true

      const provinceAddress = this.consultantForm.region
      const addressInfo = {
        provinceName: provinceAddress[0].split(',')[0] || '',
        provinceCode: provinceAddress[0].split(',')[1] || '',
        cityName: provinceAddress[1] ? (provinceAddress[1].split(',')[0] || '') : '',
        cityCode: provinceAddress[1] ? (provinceAddress[1].split(',')[1] || '' ): '',
        districtName: provinceAddress[2] ? (provinceAddress[2].split(',')[0] || '') : '',
        districtCode: provinceAddress[2] ? (provinceAddress[2].split(',')[1] || '') : '',
      };
      const addParams = JSON.parse(JSON.stringify({
        ...this.consultantForm,
        ...addressInfo
      }))
      delete addParams.region;
      try {
        let addRes = await this.$API.addPatient({
          ...addParams
        });
        // ----------------test------------------
        // addRes = {"code":"0","msg":"","data":"001","success":false}
        // ----------------test------------------
        console.log('新增就诊人接口', addRes)
        if (addRes.code == 0) {
          this.$message.success('新增成功！')
          // TODO: 360视图 0---
          // this.signSingleNew(addRes.data);
          // TODO: 360视图 1---
          this.closePop()
        } else {
          this.$message.error(addRes.msg);
        }
        this.confirm = false
        this.getPatientList() // 获取就诊人列表,会进行登录判断
      } catch (error) {}
    },
    async signSingleNew(hisId) {
      const _this = this;
      try {
        // 去签署
        const signStatus = _this.consultantForm.agree360Check ? "1" : "0";
          console.log('this.consultantForm', this.consultantForm)
          const sendMsg = {
            hospitalCode: _this.hospitalCode,
            hisId: hisId,
            patientName: _this.consultantForm.name,
            micId: _this.mic.latestMic.id,
            micVersion: _this.mic.latestMic.micVersion,
            signStatus,
            secondSource: MIC_CONFIG.source, // 正式：boegw  测试：GW
          }
          console.log('360视图 0', sendMsg)
          const micSignRes = await this.$API.getMicSignSingle(sendMsg);
      } catch (error) {}
    },
    handleSubmitAddPatient(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
        }
      })
    },
    // 关闭新增就诊人弹框
    closePop() {
      this.confirm = false
      this.consultantForm = {
        sys: 'ohealth',
        hospitalCode: 'H05',
        name: '',
        phone: '',
        idType: '01',
        idNo: '',
        birthday: '',
        gender: '1',
        relation: '0',
        verifyCode: '',
        source: 'web',
        nation: '01',
      }
    },
    handleSelectChange(value) {
      console.log(value)
      return value
      // this.handleConsultantOk();
    },
    // getPatientDeatil() {
    //   this.$API
    //     .getPatientDeatil({
    //       hospitalCode: 'H05',
    //       hisId: this.hisPatientId,
    //     })
    //     .then((res) => {
    //       console.log('res----', res.data)
    //       this.$set(this, 'patientDeatiDataPhone', res.data.phone)
    //       this.$set(this, 'idNo', res.data.idNo)
    //     })
    // },
    // 切换就诊人
    handleSelectChangehisPatientNameList(hisPatientId) {
      this.hisPatientId = hisPatientId;
      for (let i = 0; i < this.hisPatientNameList.length; i++) {
        if (this.hisPatientNameList[i].hisId == hisPatientId) {
          // this.$set(this, "patientDeatiData", this.hisPatientNameList[i]);
          this.idNo = this.hisPatientNameList[i].idNo;
          this.idNoHide = this.hisPatientNameList[i].idNoHide;
          this.phone = this.hisPatientNameList[i].phone;
          this.sex = this.hisPatientNameList[i].gender;
          this.curPatient = this.hisPatientNameList[i];
        }
      }
      console.log(' this.hisPatientId ----------------', hisPatientId)
      // this.queryMicSignStatus();
    },
    // 加密
    setEncrypt(msg) {
      let jsencrypt = new JSEncrypt({})
      jsencrypt.setPublicKey(this.publicKey)
      return jsencrypt.encrypt(msg)
    },
    //获取验证码
    getVerifyCode(value) {
      if (!this.consultantForm.phone) {
        this.$message.warning('请输入手机号')
        return
      }
      if (this.codeTimer) {
        return
      }
      // let obj = {
      //   phone: this.consultantForm.phone,
      //   language: 'zh',
      //   purpose: 'V',
      //   sys: 'ohealth',
      //   templateNo: 'h05-website',
      // }
      let phone = this.setEncrypt(this.consultantForm.phone)
      let language = this.setEncrypt('zh')
      let purpose = this.setEncrypt('V')
      let sys = this.setEncrypt('ohealth') //合肥sys传h02site,苏州成都传ohealth
      let templateNo = this.setEncrypt('h05-website')
      let hospitalCode = this.setEncrypt('H05')
      let obj = {
        phone: phone,
        language: language,
        purpose: purpose,
        sys: sys,
        templateNo: templateNo,
        hospitalCode: hospitalCode,
      }
      this.$API.sendCode(obj).then((res) => {
        if (res.code == 0) {
          this.$message.success('获取验证码成功！')
          this.codeTimer = setInterval(() => {
            this.codeSecond--
            if (this.codeSecond == 0) {
              clearTimeout(this.codeTimer)
              this.codeTimer = null
            }
          }, 1000)
        } else {
          this.$message.error(res.msg)
        }
        this.codeSecond = 120
      })
    },
    // current2 确认预约预约成功current3
    async handleSubmit() {
      if (this.dutyId == '') {
        this.$message.warning('请选择时间段')
        return
      }
      if (this.sectionNo == '') {
        this.$message.warning('请选择号源')
        return
      }
      if (this.hisPatientId == '') {
        this.$message.warning('请选择就诊人')
        return
      }
      // 判断就诊人性别与科室是否合适
      if(this.sex == '1'){
        if(this.womandeptArr.includes(this.hisDeptId)){
          this.$message.warning("男性不能选择女性科室");
          return
        }
      }else{
        if(this.mandeptArr.includes(this.hisDeptId)){
          this.$message.warning("女性不能选择男性科室");
          return
        }
      }
      /* this.$loading();
      this.current = 3
      this.addWebsiteBook() */
      const patientInfo = this.curPatient || {};
      const {hisId, name} = patientInfo;
      const {signStatus, micVersion, id } = this.mic.curMic;
      // try {
      //   /*
      //     360视图签署
      //     判断当前是否签署过，如果签署过则不用再次签署
      //     signStatus: 1 签署过 0 没签署过
      //   */
      //   const signStatusNum = this.agreeCheck ? "1" : "0";
      //   if (signStatus == 0) {
      //     // 去签署
      //     const sendMsg = {
      //       hospitalCode: 'H05',
      //       hisId: hisId,
      //       patientName: name,
      //       micId: id,
      //       micVersion,
      //       signStatus: signStatusNum,
      //       secondSource: MIC_CONFIG.source // 正式：boegw  测试：GW
      //     }
      //     console.log(sendMsg)
      //     const micSignRes = await this.$API.getMicSignSingle(sendMsg);
      //   }
      // } catch (error) {}

      this.current = 3
      this.$loading()
      this.addWebsiteBook()

    },
    getCurrentDateWeek(myDate) {
      var year = myDate.getFullYear() //获取年
      var month = myDate.getMonth() + 1 //获取月，默认从0开始，所以要加一
      var date = myDate.getDate() //获取日
      var weekend = myDate.getDay() //获取星期几，这里获得到的是数字1-7，所以我下面自己new了一个数组把获取到的数字当下标
      var weeks = new Array(
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      )
      var day = weeks[weekend] //这样就是显示的星期x了 //这些if判断是在小于10的时候前面自动补0
      var rslt = {}
      if (month < 10) {
        month = '0' + month
      }
      if (date < 10) {
        date = '0' + date
      }
      date = year + '-' + month + '-' + date
      var week = '(' + day + ')'
      rslt = { date: date, week: week }
      return rslt
    },
    getCurrentDateWeek7() {
      // var startDate = new Date();
      // var endDate = new Date();
      // var dateList = [];
      // endDate.setDate(startDate.getDate() + 30);
      // console.log("endDate:",endDate)
      // while((endDate.getTime()-startDate.getTime())>=0){
      //   let month=(startDate.getMonth() + 1).toString().length === 1 ? "0" + (startDate.getMonth() + 1).toString() : (startDate.getMonth() + 1);        let day = startDate.getDate().toString().length === 1 ? "0" + startDate.getDate() : startDate.getDate();
      //   dateList.push(month + "-" + day);
      //   startDate.setDate(startDate.getDate() + 1);
      // }
      // console.log("dateList:",dateList);

      for (var i = 0; i < 30; i++) {
        var myDate = new Date()
        var date2 = new Date()
        date2.setDate(myDate.getDate() + i)
        console.log('week 7 i:', i)
        console.log('week 7 myDate.getDate():', myDate.getDate())
        console.log('week 7:', myDate.getDate() + i)
        console.log('week 7 date2:', date2)
        var rslt = this.getCurrentDateWeek(date2)
        this.weekList[i] = { date: rslt.date, week: rslt.week }
      }
    },
    //科室下排班医生列表
    getDutyList() {
      this.dutyDoctorIdList = ''
      this.$API
        .getDutyList({
          hospitalCode: 'H05',
          hisDeptId: this.hisDeptId,
          dutyDate: this.dutyDate,
        })
        .then((res) => {
          this.$set(this, 'dutyList', res.data)
          console.log('dutyList----------------', this.dutyList)
          for (let i = 0; i < this.dutyList.length; i++) {
            if (i == 0) {
              this.dutyDoctorIdList = this.dutyList[i].hisDoctorId
            } else {
              this.dutyDoctorIdList =
                this.dutyDoctorIdList + ',' + this.dutyList[i].hisDoctorId
            }
          }
          // this.getDoctorDutyList()
        })
    },
    // 获取同专业医生推荐列表
    getDoctorDutyList() {
      this.$API
        .getDoctorDutyList({
          hospitalCode: 'H05',
          hisDeptId: this.hisDeptId,
          hisId: this.dutyDoctorIdList,
        })
        .then((res) => {
          this.doctorList = res.data
          console.log('getDoctorDutyList', this.doctorList)
        })
    },
    // 点击同专业医生，获取医生排班
    chooseDoctor(value) {
      console.log('chooseDoctor dutyDate', this.weekList[0].date)
      this.$API
        .getDutyDoctorDetail({
          hospitalCode: 'H05',
          hisDoctorId: value.hisId,
          hisDeptId: this.hisDeptId,
          dutyDate: this.weekList[0].date,
        })
        .then((res) => {
          // this.doctorList = res.data;
          console.log('checkDoctorDuty:', res)
          if (res && res.code == '0') {
            console.log('checkDoctorDuty data length:', res.data.length)
            if (res.data.length == 0) {
              this.$message.warning('该医生最近30天内暂无排班')
            } else {
              this.firstDoctorDutyDate = res.data[0].dutyDate
              console.log(
                'checkDoctorDuty firstDoctorDutyDate:',
                this.firstDoctorDutyDate
              )
              for (let i = 0; i < this.weekList.length; i++) {
                if (this.weekList[i].date == this.firstDoctorDutyDate) {
                  this.changeDateStyle(i)
                  this.currentDateIndex = i
                }
              }
            }
          }
        })
    },

    //医生分时段排班明细
    getDutyDoctorDetail() {
      this.$API
        .getDutyDoctorDetail({
          hospitalCode: 'H05',
          hisDeptId: this.hisDeptId,
          hisDoctorId: this.hisDoctorId,
          dutyDate: this.dutyDate,
        })
        .then((res) => {
          this.$set(this, 'dutyDoctorDetailList', res.data)
          console.log(
            'dutyDoctorDetailList----------------',
            this.dutyDoctorDetailList
          )
          if (this.dutyDoctorDetailList.pmList.length > 0) {
            this.showAMTime = -1
            this.showPMTime = 0
            for (var i = 0; i < this.dutyDoctorDetailList.pmList.length; i++) {
              if (this.dutyDoctorDetailList.pmList[i].available == 1) {
                this.currentTimeSpanIndexPM = i
                this.currentTimeSpanIndexAM = -1
                this.dutyId = this.dutyDoctorDetailList.pmList[i].dutyId
                this.orderTime =
                  this.dutyDate +
                  ' ' +
                  this.dutyDoctorDetailList.pmList[i].startTime +
                  '-' +
                  this.dutyDoctorDetailList.pmList[i].endTime

                for (
                  var j = 0;
                  j < this.dutyDoctorDetailList.pmList[i].sectionNoList.length;
                  j++
                ) {
                  if (
                    this.dutyDoctorDetailList.pmList[i].sectionNoList[j]
                      .available == 1
                  ) {
                    this.currentSectionNoIndexPM = j
                    this.currentSectionNoIndexAM = -1
                    this.sectionNo = this.dutyDoctorDetailList.pmList[
                      i
                    ].sectionNoList[j].sectionNo
                    break
                  }
                }
                break
              }
            }
          }
          if (this.dutyDoctorDetailList.amList.length > 0) {
            this.showPMTime = -1
            this.showAMTime = 0
            for (var i = 0; i < this.dutyDoctorDetailList.amList.length; i++) {
              if (this.dutyDoctorDetailList.amList[i].available == 1) {
                this.currentTimeSpanIndexAM = i
                // this.currentTimeSpanIndexPM = -1;
                this.dutyId = this.dutyDoctorDetailList.amList[i].dutyId
                this.orderTime =
                  this.dutyDate +
                  ' ' +
                  this.dutyDoctorDetailList.amList[i].startTime +
                  '-' +
                  this.dutyDoctorDetailList.amList[i].endTime

                for (
                  var j = 0;
                  j < this.dutyDoctorDetailList.amList[i].sectionNoList.length;
                  j++
                ) {
                  if (
                    this.dutyDoctorDetailList.amList[i].sectionNoList[j]
                      .available == 1
                  ) {
                    this.currentSectionNoIndexAM = j
                    // this.currentSectionNoIndexPM = -1;
                    this.sectionNo = this.dutyDoctorDetailList.amList[
                      i
                    ].sectionNoList[j].sectionNo
                    break
                  }
                }
                break
              }
            }
          }

          console.log(
            'dutyDoctorDetailList----------------',
            this.dutyDoctorDetailList
          )
        })
    },
    //box3获取上午可选时间段
    getCurrentTimeSpan(ifmorning, index) {
      if (ifmorning == 0) {
        this.sectionNo = this.dutyDoctorDetailList.amList[
          index
        ].sectionNoList[0].sectionNo
        // this.sectionNo = 0;
        this.currentTimeSpanIndexAM = index
        this.showAMTime = index
        this.showPMTime = -1
        // this.currentTimeSpanIndexPM = -1;
        this.currentSectionNoIndexAM = 0
        this.dutyId = this.dutyDoctorDetailList.amList[index].dutyId
        this.orderTime =
          this.dutyDate +
          ' ' +
          this.dutyDoctorDetailList.amList[index].startTime +
          '-' +
          this.dutyDoctorDetailList.amList[index].endTime
      }
      if (ifmorning == 1) {
        this.sectionNo = this.dutyDoctorDetailList.pmList[
          index
        ].sectionNoList[0].sectionNo
        this.currentTimeSpanIndexPM = index
        this.showPMTime = index
        this.showAMTime = -1
        // this.currentTimeSpanIndexAM = -1;
        this.currentSectionNoIndexPM = 0
        this.dutyId = this.dutyDoctorDetailList.pmList[index].dutyId
        this.orderTime =
          this.dutyDate +
          ' ' +
          this.dutyDoctorDetailList.pmList[index].startTime +
          '-' +
          this.dutyDoctorDetailList.pmList[index].endTime
      }
    },

    getCurrentSectionNo(ifmorning, index) {
      if (ifmorning == 0) {
        this.currentSectionNoIndexAM = index
        this.sectionNo = this.dutyDoctorDetailList.amList[
          this.currentTimeSpanIndexAM
        ].sectionNoList[index].sectionNo
      }
      if (ifmorning == 1) {
        this.currentSectionNoIndexPM = index
        this.sectionNo = this.dutyDoctorDetailList.pmList[
          this.currentTimeSpanIndexPM
        ].sectionNoList[index].sectionNo
      }
    },
    // 获取公匙
    getPublicKey() {
      this.$API.rsaPublic().then((res) => {
        if (res.code == 0) {
          this.publicKey = res.data
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    //获取就诊人列表
    getPatientList() {
      let ut = localStorage.getItem('ut')
      // localStorage中没有ut，判断是否登录
      if (ut == undefined || ut == null || ut == '') {
        this.showLoginMask = true
        return
      }
      this.$API
        .patientList({
          hospitalCode: 'H05',
        })
        .then(
          (res) => {
            this.$set(this, 'hisPatientNameList', res.data)
            if (this.hisPatientNameList.length > 0) {
              let that = this
              let eCardFlag = true
              this.hisPatientNameList.forEach((item, i) => {
                if (
                  item.ehealthCardId == undefined ||
                  item.ehealthCardId == null ||
                  item.ehealthCardId == ''
                ) {
                  eCardFlag = false
                }
              })
              if (eCardFlag) {
              } else {
                this.$warning({
                  content: '本院就诊卡已全面升级为电子健康卡',
                  okText: '确认升级',
                  onOk() {
                    that.updateEHealthCard()
                  },
                })
                return
              }
            }
          },
          (error) => {
            if (error.code == '9999') {
              this.showLoginMask = true
            }
          }
        )
    },
    // 更新电子健康卡
    updateEHealthCard() {
      var ids = []
      this.hisPatientNameList.forEach((item) => {
        if (
          item.ehealthCardId == undefined ||
          item.ehealthCardId == null ||
          item.ehealthCardId == ''
        ) {
          ids.push(item.id)
        }
      })
      console.log('updateEHealthCard ids:', ids)
      let params = {
        ids: ids,
      }
      this.$API.updateEHealthCard(params).then((res) => {
        if (res && res.code == 0) {
          console.log('updateEHealthCard res:', res)
          this.$message.success('更新成功！')
          this.getPatientList()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 网站确认预约
    addWebsiteBook() {
      console.log('this.sectionNo', this.sectionNo)
      console.log('this.dutyId', this.dutyId)
      console.log('this.orderTime', this.orderTime)
      debugger;
      this.$API
        .addBook({
          hospitalCode: 'H05',
          hisPatientId: this.hisPatientId,
          dutyId: this.dutyId,
          sectionNo: this.sectionNo,
          hisDeptId: this.hisDeptId,
          hisDoctorId: this.hisDoctorId,
          sys: 'WEB',
          orderTime: this.orderTime,
          ////////////////////成都wx公众号入参///////////////////
          // const par = {
          // hospitalCode: store.hospitalCode || 'H05',
          // hisPatientId: patientInfo?.hisId,
          // dutyId: orderInfo?.dutyId,
          // sectionNo: orderInfo?.sectionNo,
          // hisDeptId: orderInfo?.hisDeptId,
          // hisDoctorId: orderInfo?.hisDoctorId,
          // orderTime: `${orderInfo?.dutyDate} ${orderInfo?.startTime}-${orderInfo?.endTime}`,
          // sys: 'WX',
    // };
        })
        .then(
          (res) => {
            console.log('addWebsiteBook res:', res)

            if (res && res.code == '0') {
              console.log('chengghggggggggggggg!')
              // this.getPatientDeatil()
              this.$set(this, 'websiteBookList', res.data)
              this.ifSuccess = true
              this.steps[3].title = '预约成功'
              this.orderCode = this.websiteBookList.orderCode
              this.fee = this.websiteBookList.fee
              this.$loading().close();
            } else {
              console.log('failfalifailfalifailfalifailfalifailfalifailfali!')
              this.ifSuccess = false
              this.steps[3].title = '预约失败'
              this.erroeMsg = res.msg
              this.$loading().close();
            }
          },
          (error) => {
            console.log(
              'failfalifailfalifailfalifailfalifailfalifailfali!',
              error
            )
            this.$loading().close();
            this.ifSuccess = false
            this.steps[3].title = '预约失败'
            this.erroeMsg = error.msg
          }
        )
    },
    // 给window加个事件
    addIframeEventListener() {
      this.showIframe = true
      document.getElementsByClassName('websiteBook')[0].style.position =
        'relative'
      document.getElementsByClassName('websiteBook')[0].style.zIndex = 1000
      let that = this
      window.addEventListener('message', function(event) {
        console.log('iframe message:', event)
        // if (event.origin == "https://ssctest.boe.com") {
          if(event.data.type){
            return
          }
        // 部署到线上后要改
        that.showIframe = false
        console.log('showIframe1:', that.showIframe)
        let data = event.data
        if (data.hisDeptId == '' && data.hisDeptName == '') {
          console.log('选择科室')
          that.current = 0
          that.getDeptList()
          that.showIframe = false
          console.log('showIframe2:', that.showIframe)
        } else {
          console.log('去对应门诊')
          that.current = 1
          that.getCurrentDateWeek7()
          that.hisDeptId = data.hisDeptId //获取科室
          that.dutyDate = that.weekList[0].date //时间
          that.getDutyList()
          that.showIframe = false
          console.log('showIframe3:', that.showIframe)
        }
        // }
      })
    },
    // 关闭不知道挂哪科弹框
    closeNoIdeaModal() {
      this.showIframe = false
      document.getElementsByClassName('websiteBook')[0].style.position = 'unset'
      document.getElementsByClassName('websiteBook')[0].style.zIndex = 5
    },

    // 门诊去付款
    goPayment() {
      if ((this.paymentLock = false)) {
        return
      }
      if ((this.paymentLock = true)) {
        this.paymentLock = false
      }
      console.log('PC端支付:', this.websiteBookList)
      let record = this.websiteBookList
      let orderCode = record.orderCode
      let hisPatientId = record.hisPatientId
      let fee = record.fee * 100 // 按分计算，返回值乘以100为元
      this.paymentRecord = record
      this.paymentFee = record.fee
      let data = {
        sys: 'H05',
        source: 'website',
        platform: 'ZN',
        payType: 'qrcode',
        businessId: 'A1',
        businessType: '预约支付',
        productId: orderCode,
        productName: '门诊预约',
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        accessType: 10,
      }
      this.$API.goPay(data).then((res) => {
        this.paymentLock = true
        console.log('goPay res:', res)
        if (res && res.code == '0') {
          this.paymentQrCode = res.data
          this.paymentVisible = true
          document.getElementsByClassName('websiteBook')[0].style.position =
            'relative'
          document.getElementsByClassName('websiteBook')[0].style.zIndex = 1000
          this.getQrCode()
        }
      })
    },

    // 生成支付二维码
    getQrCode() {
      this.timer = setInterval(this.clock, 1000)
      let that = this
      // this.paymentQrCode="https://qr.95516.com/01020001/wcqr?f=ICBCqr&X=1&T=3&P=13&I=e03d925776684b4d&N=eda2cd4a81a690c8a44f6a1288309c1b&L=0fe51c864aef965d696f79225b4a271785d4670d20ce2e676a7e89b9a1d132589704dc03df521bc68c70ba61e2622fa2"
      console.log('this inside qrcode:', that.paymentQrCode)
      let qrcode = require('qrcodejs2')
      document.getElementById('qrcode').innerHTML = ''
      new qrcode(document.getElementById('qrcode'), {
        text: that.paymentQrCode,
        width: 183,
        height: 183,
        correctLevel: qrcode.CorrectLevel.Q,
      })
    },
    // 计时器
    clock() {
      if (this.num > 0) {
        this.checkPaymentStatus() // 检查门诊预约支付状态
        this.num--
      } else {
        // this.closePaymentModal();
        clearInterval(this.timer)
        this.num = 60
        this.goPayment()
      }
    },
    // 查询门诊支付状态
    checkPaymentStatus() {
      let data = {
        hospitalCode: "H05",
        hisPatientId: this.paymentRecord.hisPatientId,
        orderCode: this.paymentRecord.orderCode,
      }
      this.$API.checkPaymentStatus(data).then(
        (res) => {
          console.log('checkPaymentStatus res:', res)
          if (res && res.code == '0') {
            if (res.data == 'P') {
              // this.getOutpatientTableList();
              if (this.SCREEN.mobile) {
                this.closePayPhoneModal() // 关闭手机端
              } else {
                this.closePaymentModal() // 关闭PC端
              }
              this.openPaySuccessModal()
            }
          }
        },
        (error) => {
          console.log('checkPaymentStatus error:', error)
          if (this.SCREEN.mobile) {
            this.closePayPhoneModal()
          } else {
            this.closePaymentModal()
          }
        }
      )
    },
    // 关闭支付弹窗
    closePaymentModal() {
      this.paymentVisible = false
      document.getElementsByClassName('websiteBook')[0].style.position = 'unset'
      document.getElementsByClassName('websiteBook')[0].style.zIndex = 5
      clearInterval(this.timer)
      this.num = 60
    },

    // 支付成功弹窗
    openPaySuccessModal() {
      this.paySuccessVisible = true
      document.getElementsByClassName('websiteBook')[0].style.position =
        'relative'
      document.getElementsByClassName('websiteBook')[0].style.zIndex = 1000
      // 支付成功计时器
      this.paySuccessTimer = setInterval(this.successClock, 1000)
    },
    // 支付成功计时器
    successClock() {
      if (this.paySuccessNum > 0) {
        this.paySuccessNum--
      } else {
        this.closePaySuccessModal()
      }
    },
    // 关闭支付成功弹窗
    closePaySuccessModal() {
      this.paySuccessVisible = false
      document.getElementsByClassName('websiteBook')[0].style.position = 'unset'
      document.getElementsByClassName('websiteBook')[0].style.zIndex = 5
      clearInterval(this.paySuccessTimer)
      this.paySuccessNum = 5
      this.$router.push("/personalCenter/personalList/#5")
    },
    // 门诊去付款手机端
    goPaymentPhone() {
      if ((this.paymentLock = false)) {
        return
      }
      if ((this.paymentLock = true)) {
        this.paymentLock = false
      }
      console.log('PC端支付:', this.websiteBookList)
      let record = this.websiteBookList
      let orderCode = record.orderCode
      let hisPatientId = record.hisPatientId
      let fee = record.fee * 100 // 按分计算，返回值乘以100为元
      this.paymentRecord = record
      this.paymentFee = record.fee
      let data = {
        sys: 'H05',
        source: 'website',
        platform: 'ZN',
        payType: 'h5',
        businessId: 'A1',
        businessType: '预约支付',
        productId: orderCode,
        productName: '门诊预约',
        totalFee: fee, // 按分计算，返回值乘以100为元
        buyerId: hisPatientId,
        accessType: 10,
      }
      this.$API.goPayPhone(data).then((res) => {
        this.paymentLock = true
        console.log('goPayPhone res:', res)
        if (res && res.code == '0') {
          this.paymentQrCode = res.data
          // this.paymentVisible = true;
          // this.getQrCode();
          let u = navigator.userAgent
          let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
          let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
          if (isAndroid) {
            //android终端
            window.open(this.paymentQrCode, '_blank')
          } else if (isiOS) {
            //ios终端
            window.location.href = this.paymentQrCode
          }
          this.openPayPhoneModal()
        }
      })
    },
    // 打开手机支付中弹框
    openPayPhoneModal() {
      // this.payPhoneVisible = true;
      // this.timer = setInterval(this.phoneClock, 1000);
      // this.showHasPaySuccess = true;
      let timer = setTimeout(() => {
        this.showHasPaySuccess = true
        clearTimeout(timer)
      }, 3000)
    },

    // 手机计时器
    phoneClock() {
      if (this.num > 0) {
        this.checkPaymentStatus() // 检查门诊预约支付状态
        this.num--
      } else {
        this.closePayPhoneModal()
      }
    },
    // 关闭手机支付中弹框
    closePayPhoneModal() {
      this.payPhoneVisible = false
      clearInterval(this.timer)
      this.num = 60
    },

    // 已完成支付
    hasPaySuccess() {
      this.showHasPaySuccess = false
      this.$router.push('/personalCenter/personalList')
    },
    // 重新支付
    refreshPay() {
      this.goPaymentPhone() // 调用门诊支付接口
    },

    // 输入身份证号自动带出出生日期
    enterIdNo() {
      if (
        this.consultantForm.idType == '01' &&
        this.consultantForm.idNo.length == 18
      ) {
        let str1 = this.consultantForm.idNo.substring(6, 10)
        let str2 = this.consultantForm.idNo.substring(10, 12)
        let str3 = this.consultantForm.idNo.substring(12, 14)
        let gender = this.consultantForm.idNo.substring(16, 17)
        this.consultantForm.birthday = str1 + '-' + str2 + '-' + str3
        if (gender % 2 == 1) {
          this.consultantForm.gender = '1'
        } else {
          this.consultantForm.gender = '2'
        }
      }
    },
  },
  beforeDestroy() {
    this.codeTimer && clearTimeout(this.codeTimer)
  },
}
</script>

<style lang="less" scoped>
.mask50 {
  background: url(../images/mask50.png);
  width: 100%;
  height: 100%;
  z-index: 2001;
  position: fixed;
  top: 0;
  left: 0;
}
.contactfixed {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2002;
  background: #fff;
  padding: 0.4rem 0.4rem 0.3rem;
  text-align: center;
  h1 {
    font-size: 0.18rem;
    line-height: 0.2rem;
  }
  .btn {
    margin-top: 0.3rem;
    a {
      font-size: 0.16rem;
      margin: 0 0.1rem;
      display: inline-block;
      height: 0.35rem;
      line-height: 0.33rem;
      padding: 0 0.5rem;
      min-width: 0.5rem;
      background: #0078c6;
      color: #fff;
      border-radius: 2rem;
    }
  }
}
/deep/.ant-steps {
  padding-top: 94px;
  .ant-steps-item-tail {
    height: 7px;
    background: #d8d8d8;
    top: 0;
    margin-left: 20px;
  }
  .ant-steps-item-content {
    text-align: left;
    width: 100%;
  }
  .ant-steps-item-tail:after {
    background: #d8d8d8;
  }
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail:after,
  .ant-steps-item-finish .ant-steps-item-tail {
    background-color: #1890ff;
  }
  .ant-steps-item-icon {
    margin-left: 0 !important;
  }
  .ant-steps-icon-dot {
    width: 0.4rem;
    height: 0.4rem;
    max-width: 24px;
    max-height: 24px;
    background: #d8d8d8;
    border-radius: 50%;
    top: 50% !important;
    transform: translateY(-50%);
    // left: 48px !important;
    // top: -24px;
    // left: -24px;
    // transform: translate(50%, 50%);
  }
  .ant-steps-item-title {
    padding-top: 20px;
    font-size: 14px !important;
    // padding-left: 70px;
  }
  .ant-steps-item-finish {
    .ant-steps-icon-dot {
      background: #0078d4 url(../images/liucheng-1.png) no-repeat center;
      background-size: 40%;
      width: 0.5rem;
      height: 0.5rem;
      max-height: 44px;
      max-width: 44px;
      top: 50% !important;
      transform: translateY(-50%);
    }
  }
  .ant-steps-item-active {
    .ant-steps-icon-dot {
      left: 0;
      width: 0.6rem;
      height: 0.6rem;
      max-width: 70px;
      max-height: 70px;
      background: #bfdaee;
      top: 50% !important;
      transform: translateY(-50%);
    }
    .ant-steps-icon-dot:after {
      background: #0078d4 url(../images/liucheng-2.png) no-repeat center;
      background-size: 40%;
      width: 0.5rem;
      height: 0.5rem;
      max-height: 44px;
      max-width: 44px;
      border-radius: 50%;
      top: 50% !important;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .ant-steps-item-wait {
    .ant-steps-icon-dot {
      background: #d8d8d8;
    }
  }
}
.detailSection {
  // position: relative;
  width: 100%;
  margin-top: 0.2rem;
  padding: 0.2rem 0.3rem 0.2rem;
  border: 1px solid #e8e8e8;
}
// .detailSection:before {
//   box-sizing: content-box;
//   width: 0px;
//   height: 0px;
//   position: absolute;
//   top: -16px;
//   right: 41px;
//   padding: 0;
//   border-bottom: 8px solid #e8e8e8;
//   border-top: 8px solid transparent;
//   border-left: 8px solid transparent;
//   border-right: 8px solid transparent;
//   display: block;
//   content: "";
//   z-index: 12;
// }
// .detailSection:after {
//   box-sizing: content-box;
//   width: 0px;
//   height: 0px;
//   position: absolute;
//   top: -18px;
//   right: 40px;
//   padding: 0;
//   border-bottom: 9px solid #e8e8e8;
//   border-top: 9px solid transparent;
//   border-left: 9px solid transparent;
//   border-right: 9px solid transparent;
//   display: block;
//   content: "";
//   z-index: 10;
// }
.box3 {
  position: relative;
  padding-top: 20px;
  .top {
    padding-top: 54px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #dbdbdb;
    .tit1 {
      font-size: 20px;
      padding-bottom: 14px;
    }

    .listLable {
      display: flex;
      align-items: center;
      padding-bottom: 0.1rem;
      .label {
        display: flex;
        margin-right: 15px;
        .left {
          width: 16px;
          height: 16px;
          background: #50b5f7;
          border-radius: 5.33px;
          border-radius: 2px;
          margin-right: 6px;
          margin-top: 3px;
        }
        .right {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.75);
        }
      }
      .label:nth-child(2) {
        .left {
          background: #6ec57a;
        }
      }
      .label:nth-child(3) {
        margin-right: 0;
        .left {
          background: #d8d8d8;
        }
      }
    }
  }
  .tip1 {
    font-size: 16px;
    line-height: 26px;
  }
  .listbox {
    margin-top: 30px;
    font-size: 16px;
    .a1 {
      width: 160px;
      margin-top: 5px;
      padding: 17px 32px;
      border: 1px solid #dddddd;
      text-align: center;
      margin-left: 20px;
      position: relative;
      display: inline-block;
      color: #ffffff;
      background: #6ec57a;
    }
    .a1.now {
      background: #50b5f7 !important;
    }
    .detailSection {
      display: flex;
      flex-wrap: wrap;
      margin-left: 0.76rem;
      //默认缺号
      .a2 {
        box-sizing: border-box;
        width: 13.42%;
        padding-top: 11px;
        padding-bottom: 11px;
        border: 1px solid #d8d8d8;
        border-left: 5px solid #d8d8d8;
        text-align: center;
        margin-left: 1%;
        margin-top: 20px;
        position: relative;
        display: inline-block;

        font-size: 18px;
        color: rgba(51, 51, 51, 0.45);
      }
      .a2:nth-child(7n + 1) {
        margin-left: 0;
      }
      .a2:nth-child(-n + 7) {
        margin-top: 0;
      }
      .a2.available {
        border: 1px solid #6ec57a;
        border-left: 5px solid #6ec57a;
        color: #333333;
      }
      .a2.unavaliable {
        pointer-events: none;
      }
      .a2.now {
        background: #50b5f7 !important;
        border: 1px solid #50b5f7;
        border-left: 5px solid #50b5f7;
        color: #ffffff;
      }
    }
    .morning,
    .afternoon {
      .s1 {
        background: url(../images/rect.svg) no-repeat center;
        background-size: cover;

        display: inline-block;
        width: 0.66rem;
        height: 0.66rem;
        line-height: 0.66rem;
        text-align: center;
        padding-right: 0.1rem;
      }
      width: 100%;

      font-size: 16px;
      color: #1890ff;
    }
  }
  /deep/.ant-form {
    padding-top: 45px;
  }
  .confirmBtn {
    margin-top: 25px;
    margin-bottom: 20px;
    a {
      background: #0078d4;
      font-size: 16px;
      border-radius: 200px;
      text-align: center;
      display: inline-block;
      padding: 12px 60px;
      color: #fff;
      &.dis {
        color: rgba(0, 0, 0, 0.25);
        background-color: #f5f5f5;
        border-color: #d9d9d9;
      }
      i {
        padding: 4px 0;
        padding-left: 43px;
        background: url(../images/guahao3page1-img2.png) no-repeat left center;
        font-style: normal;
        color: inherit;
        display: inline-block;
      }
    }
  }
  .guahao3page1_alert {
    -webkit-box-shadow: 0px 1px 12px 0px #f5f5f5;
    box-shadow: 0px 1px 12px 0px #f5f5f5;
    width: 100%;
    min-height: 470px;
    position: absolute;
    bottom: -20px;
    left: 0;
    background: #fff;
    z-index: 999;
    .close {
      position: absolute;
      top: 20px;
      right: 21px;
      background: url(../images/close.jpg) no-repeat center;
      display: block;
      width: 23px;
      height: 23px;
    }
    .inner {
      padding: 55px 60px;
      padding-bottom: 80px;
      .tit2 {
        font-size: 30px;
      }
      .ant-form {
        // margin-top: 34px;
        display: flex;
        flex-wrap: wrap;
        .ant-form-item {
          width: 30%;
          margin: 0;
          margin-bottom: 20px;
        }
      }

      .guahao3page1-button {
        margin-top: 25px;
        a {
          background: #0078d4;
          font-size: 16px;
          border-radius: 200px;
          text-align: center;
          display: inline-block;
          padding: 12px 60px;
          color: #fff;
          &.dis {
            color: rgba(0, 0, 0, 0.25);
            background-color: #f5f5f5;
            border-color: #d9d9d9;
          }
          i {
            padding: 4px 0;
            padding-left: 43px;
            background: url(../images/guahao3page1-img2.png) no-repeat left
              center;
            font-style: normal;
            color: inherit;
            display: inline-block;
          }
        }
      }
    }
  }
}
.box2 {
  padding-top: 35px;
  width: 100%;
  .dateBox {
    width: 100%;
    overflow-x: auto;
  }
  .tabgs {
    width: auto;
    -webkit-box-shadow: 0px 1px 12px 0px #f5f5f5;
    box-shadow: 0px 1px 12px 0px #f5f5f5;
    display: flex;
    justify-content: space-between;
    .item {
      // width: 174.8px;
      // flex: 1;
      flex-shrink: 0;
      border-left: 1px solid #dfdfdf;
      text-align: center;
      color: #707070;
      padding: 16px 30px;
      font-size: 18px;
      cursor: pointer;
      padding-bottom: 14px;
      .date {
        line-height: 1;
      }
    }
    .item.now {
      color: #fff;
      background: #0078d4;
    }
  }
  .table {
    margin-top: 30px;
    /deep/.ant-table-thead > tr:first-child > th {
      background: #0078d4;
      font-size: 16px;
      height: 56px;
      text-align: center;
      color: #fff;
      font-weight: 100;
      border-left: 2px solid #fff;
    }
    /deep/.ant-table-tbody > tr > td {
      text-align: center;
      color: #474747;
      a {
        color: #474747;
      }
    }
  }
  .noData {
    margin-top: 0.4rem;
    text-align: center;
    padding: 10px 0;
    border: 1px solid #dfdfdf;
  }
  .recommend {
    display: none;
    margin-top: 0.4rem;
    .mainTitle {
      font-size: 0.3rem;
      text-align: center;
      padding-bottom: 15px;
    }
    .viewMore {
      padding-bottom: 40px;
    }
    .content {
      text-align: center;
    }
    .title {
      display: inline-block;
      border-radius: 0.2rem;
      background: #f5f5f5;
      border: 1px solid #0078d4;
      padding: 0.05rem 0.2rem;
      background: #0078d4;
      color: #fff;
      font-size: 0.14rem;
    }
    .mbox1 {
      display: flex;
      justify-content: center;
      width: 100%;
      .item {
        width: 24%;
        margin-left: 1.33%;
        cursor: pointer;
        position: relative;
        a {
          .img1 {
            overflow: hidden;
            margin: 0;
            img {
              width: 100%;
              // height: 100%;
            }
          }
          .text {
            text-align: left;
            background: #fff;
            -webkit-box-shadow: 0px 1px 12px 0px #f5f5f5;
            box-shadow: 0px 1px 12px 0px #f5f5f5;
            -webkit-transition: background 0.4s ease;
            transition: background 0.4s ease;
            padding: 0.26rem;
            bottom: -0.9rem;
            left: 0.2rem;
            right: 0.2rem;
            position: absolute;
            .tit {
              font-size: 0.18rem;
              color: #333333 !important;
            }
            .tit1 {
              color: #0078d4;
              margin-top: 0.05rem;
              height: 0.42rem;
              overflow: hidden;
            }
            .desc {
              margin-top: 0.06rem;
              color: #999999;
              height: 0.65rem;
              overflow: hidden;
              line-height: 0.22rem;
              word-break: break-all;
              text-align: justify;
            }
          }
        }
      }
      .item:nth-child(0) {
        margin-left: 0;
      }
      .item:hover {
        .text {
          background: #0078d4;
          .tit,
          .tit1,
          .desc {
            color: #fff !important;
          }
        }
      }
    }
    .button {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      width: 0.98rem;
      height: 0.33rem;
      margin: auto;
      z-index: 999;
      div {
        background: url(../images/brief2-img1.png) no-repeat 0 0;
        width: 0.33rem;
        height: 0.33rem;
        background-size: 0.68rem;
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        position: absolute;
        top: 0;
        margin: auto;
        bottom: 0;
        border-radius: 0.05rem;
        z-index: 2;
        cursor: pointer;
        color: #fff;
        text-align: center;
        opacity: 0.8;
      }
      div:hover {
        opacity: 1;
      }
      .swiper-button-prev03 {
        background-position: left top;
        left: 0;
        &:focus {
          outline: none;
        }
      }

      .swiper-button-prev03:hover {
        background-position: left bottom;
      }
      .swiper-button-next03 {
        background-position: right top;
        right: 0;
        &:focus {
          outline: none;
        }
      }
      .swiper-button-next03:hover {
        background-position: right bottom;
      }
      .swiper-button-prev03:after {
        background: #0078c6;
        content: '';
        display: block;
        width: 0.2rem;
        height: 0.01rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: 0.22rem;
      }
    }

    /deep/.swiper-container {
      height: auto;
      overflow: visible !important;
    }

    /deep/.swiper-slide-shadow-left {
      background: none;
    }
    /deep/.swiper-slide-shadow-right {
      background: none;
    }

    /deep/.slick-slider slick-initialized {
      padding-bottom: 30px;
    }
  }
}
.box4 {
  padding-top: 55px;
  .boxSuccess {
    padding-top: 55px;
    .statebox {
      font-size: 30px;
      background: url(../images/guahao4page1.png) no-repeat center top;
      padding-top: 175px;
      text-align: center;
      font-weight: bold;
      .tit {
      }
      .btnSearch {
        margin-top: 72px;
        display: flex;
        justify-content: center;
        > a {
          font-size: 18px;
          color: #ffffff;
          text-align: center;
          font-weight: 700;
          width: 240px;
          height: 56px;
          line-height: 56px;

          display: block;

          border-radius: 34px;
          span {
            position: relative;
            display: inline-block;
          }

          span:before {
            content: '';
            display: block;

            width: 20px;
            height: 20px;
            position: absolute;
            top: 50%;
            margin-top: -10px;
            left: 0;
          }
        }
        .btn2_book {
          background: #65b3ec;
          margin-right: 40px;
          span {
            padding-left: 30px;
          }
          span:before {
            background: url(../images/addpatient_alert1-img2.png) no-repeat
              center;
            background-size: cover;
          }
        }
        .btn2_pay {
          background: #0078d4;
          span {
            padding-left: 30px;
          }
          span:before {
            background: url(../images/pay_button_icon.svg) no-repeat center;
          }
        }
      }
    }
    .box2box {
      .boxitem {
        padding-top: 45px;
        .tit1 {
          font-size: 20px;
          border-bottom: 1px solid #dbdbdb;
          padding-bottom: 14px;
        }
        .textlist {
          padding: 30px 0 0;
          display: flex;
          flex-wrap: wrap;
          .item1 {
            margin-right: 162px;
            font-size: 14px;
          }
        }
      }
      .boxitem:nth-child(1) {
        padding-top: 70px;
      }
      .boxitem:nth-child(2) {
        .textlist {
          .item1 {
            margin-right: 70px;
          }
        }
      }
    }
  }
  .boxFail {
    .statebox {
      background-size: 143px 143px !important;
      font-size: 30px;
      text-align: center;
      font-weight: bold;
      background: url(../images/cha.png) no-repeat center top;
      padding-top: 175px;
    }
  }
}

// 支付蒙层
.wemsk {
  background: url(../images/mask50.png);
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  left: 0;
  top: 0;
  display: block;
}

// 支付弹框
.pay-model-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -288px;
  margin-left: -331px;
  width: 662px;
  height: 576px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 4px;
  .pay-main-box {
    .title {
      width: 100%;
      height: 120px;
      background-color: #f8f9ff;
      .top-title {
        padding-top: 20px;
        text-align: center;
        font-size: 18px;
        position: relative;
        font-weight: bold;
        .close-span {
          position: absolute;
          right: 20px;
          top: 0px;
          color: #999;
          font-size: 30px;
          font-weight: normal;
        }
      }
      .two-box {
        margin: 10px 0;
        text-align: center;
        font-size: 12px;
        span {
          font-weight: bold;
        }
      }
      .three-box {
        text-align: center;
        span {
          font-weight: bold;
        }
      }
    }
    .pay-money {
      text-align: center;
      font-weight: bold;
      font-size: 14px;
      span {
        color: #ff4d4f;
        font-size: 24px;
      }
    }
    .img-box {
      margin-top: 20px;
      box-sizing: border-box;
      padding: 0 80px;
      display: flex;
      justify-content: space-between;
      .left-img-box {
        border: 1px solid #ddd;
        .qrcode-out-box {
          padding: 20px;
          .qrcode-box {
            width: 183px;
            height: 183px;
          }
        }
        .bottom-remind-box {
          box-sizing: border-box;
          // margin-top: 12px;
          padding-top: 8px;
          padding-left: 20px;
          border-top: 1px solid #ddd;
          &::after {
            clear: both;
            display: block;
            content: '';
            overflow: hidden;
          }
          .img {
            float: left;
          }
          .txt {
            margin-left: 20px;
            float: left;
            font-size: 12px;
          }
        }
      }
      .right-img-box {
        img {
          width: 210px;
          height: 288px;
        }
      }
    }
    .red-txt-box {
      margin-top: 20px;
      padding: 0 80px;
      .content-red-box {
        background-color: #fff1f0;
        border: 1px solid #ffa39e;
        padding-left: 24px;
        height: 40px;
        line-height: 40px;
        img {
          margin-right: 8px;
          display: inline;
        }
      }
    }
  }
}
// 支付成功弹框
.pay-success-model-box {
  position: fixed;
  top: 50%;
  left: 50%;
  margin-top: -130px;
  margin-left: -331px;
  width: 662px;
  height: 260px;
  z-index: 9999;
  background-color: #fff;
  border-radius: 4px;
  .top-title {
    margin-top: 20px;
    text-align: center;
    font-size: 18px;
    position: relative;
    font-weight: bold;
    .close-span {
      position: absolute;
      right: 20px;
      top: -16px;
      color: #999;
      font-size: 30px;
      font-weight: normal;
    }
  }
  .middle-box {
    margin: 60px 0;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    img {
      width: 50px;
      height: 50px;
      display: inline;
      margin-right: 20px;
    }
    span {
      color: #ff7f81;
    }
  }
  .bottom-box {
    text-align: center;
    font-size: 12px;
    color: #404555;
  }
}

// 手机支付弹框
.has-pay-success {
  position: fixed;
  width: 4rem;
  height: 2.5rem;
  z-index: 9999;
  top: 30%;
  left: 20%;
  background-color: #fff;
  border-radius: 6px;
  .gth-box {
    margin-top: 0.2rem;
    text-align: center;
    .gth {
      display: inline-block;
      width: 0.5rem;
      height: 0.5rem;
      border-radius: 50%;
      border: 1px solid red;
      color: red;
    }
  }
  .txt {
    margin: 10px 0;
    text-align: center;
  }
  .btn-box {
    display: flex;
    justify-content: space-between;
    padding: 0 0.2rem;
    p {
      border: 1px solid #ddd;
      padding: 0.1rem 0.2rem;
      border-radius: 0.5rem;
    }
    .red-btn {
      background-color: red;
      border-color: red;
      color: #fff;
    }
  }
}

.m-screen-pc {
  .m-main {
    padding-bottom: 1.5rem;
  }
  .chooseDep {
    margin-top: 46px;
    font-size: 16px;
    color: #0078d4;
  }
  .box1 {
    width: 100%;
    border: 2px solid #dfdfdf;
    font-size: 16px;
    margin-top: 30px;
    .item {
      display: flex;
      align-items: flex-start;
      border-top: 2px solid #dfdfdf;
      .s1 {
        width: 132px;
        text-align: center;

        height: 100%;
        padding-bottom: 0;
        padding: 40px 10px 0;
      }
      .list {
        flex: 1;
        border-left: 1px solid #dfdfdf;
        padding: 40px 0;
        padding-left: 45px;
        a {
          width: 20%;
          padding-right: 2%;
          display: inline-block;
          color: #333;
        }
      }
    }
    .item:first-child {
      border-top: 0;
    }
  }
  .noIdea {
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -290px;
    margin-left: -395px;
    width: 790px;
    height: 580px;
    z-index: 9999;
    background-color: #fff;
    border-radius: 4px;
    padding: 5px 10px 10px;
    .noIdeaClose {
      text-align: right;
    }
    .iframe-box {
      width: 770px;
      height: 550px;
    }
  }
  // .iframe-box {
  //   position: fixed;
  //   top: 5%;
  //   left: 20%;
  //   width: 800px;
  //   height: 600px;
  //   box-shadow: 4px 4px 4px #ddd;
  //   border-radius: 4px;
  //   z-index: 9999;
  // }
  /deep/ .ant-steps-item-active {
    .ant-steps-icon-dot {
      width: 1rem !important;
      height: 1rem !important;
    }
  }

  .mbox1_swiper {
    text-align: center;
    position: relative;
    .swiper {
      width: 100%;

      .swiper-slide {
        // width: 25%;
        cursor: pointer;
        position: relative;
        a {
          .img1 {
            overflow: hidden;
            margin: 0;
            img {
              width: 100%;
              // width: 300px;
              // height: 100%;
            }
          }
          .text {
            text-align: left;
            background: #fff;
            -webkit-box-shadow: 0px 1px 12px 0px #f5f5f5;
            box-shadow: 0px 1px 12px 0px #f5f5f5;
            -webkit-transition: background 0.4s ease;
            transition: background 0.4s ease;
            padding: 0.26rem;
            bottom: -0.9rem;
            left: 0.2rem;
            right: 0.2rem;
            position: absolute;
            .tit {
              font-size: 0.18rem;
              color: #333333 !important;
            }
            .tit1 {
              color: #0078d4;
              margin-top: 0.05rem;
              height: 0.42rem;
              overflow: hidden;
            }
            .desc {
              margin-top: 0.06rem;
              color: #999999;
              height: 0.65rem;
              overflow: hidden;
              line-height: 0.22rem;
              word-break: break-all;
              text-align: justify;
            }
          }
        }
      }
      .swiper-slide:hover {
        .text {
          background: #0078d4;
          .tit,
          .tit1,
          .desc {
            color: #fff !important;
          }
        }
      }
    }
  }
}

/deep/.ant-steps-dot .ant-steps-item-icon,
.ant-steps-dot.ant-steps-small .ant-steps-item-icon {
  margin-left: 0 !important;
}
.m-screen-mobile {
  /deep/.ant-steps {
    padding-top: 30px;
    .ant-steps-item {
      // flex: none;
      // width: 25% !important;
    }
  }
  position: relative;
  padding: 0 !important;
  padding: 0 0.25rem !important;
  margin-bottom: 1rem;
  .chooseDep {
    margin-top: 0.3rem;
    font-size: 16px;
    color: #0078d4;
  }
  .box1 {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;

    width: 100%;
    border: 2px solid #dfdfdf;
    font-size: 16px;
    .item {
      text-align: center;
      border-top: 2px solid #dfdfdf;
      .s1 {
        background: none;
        width: 100%;
        padding: 0.2rem 0.2rem;
        font-size: 0.3rem;
        box-sizing: border-box;
      }
      .list {
        text-align: left;
        border-top: 2px solid #dfdfdf;
        margin: 0;
        padding: 0.3rem 0.2rem;
        font-size: 14px;

        a {
          width: 50%;
          padding-right: 2%;
          display: inline-block;
          color: #333;
          line-height: 30px;
        }
      }
    }
    .item:first-child {
      border-top: 0;
    }
  }
  .box2 {
    margin-top: 0;
    width: 100%;
    .tabgs {
      font-size: 0;
      white-space: nowrap;
      overflow-x: auto;
      display: flex;
      justify-content: space-between;
      .item {
        font-size: 0.26rem;
        padding: 0.2rem 0.4rem;
        display: inline-block;
      }
    }
    .table {
      margin-top: 0.4rem;
      /deep/.ant-table-thead > tr:first-child > th {
        font-size: 0.3rem;
      }
      /deep/.ant-table-tbody > tr > td {
        border: 1px solid #dfdfdf;
      }
    }
    .noData {
      margin-top: 0.4rem;
      text-align: center;
      padding: 10px 0;
      border: 1px solid #dfdfdf;
    }
    .recommend {
      display: none;
      margin-top: 0.4rem;
      .m-main {
        padding-bottom: 1.58rem;
      }
      .mbox1 {
        .item {
          width: 100%;
        }
      }
      .mbox1_swiper {
        text-align: center;
        position: relative;
        .swiper {
          width: 100%;

          .swiper-slide {
            // width: 25%;
            cursor: pointer;
            position: relative;
            a {
              .img1 {
                overflow: hidden;
                margin: 0;
                img {
                  width: 100%;
                  // height: 100%;
                }
              }
              .text {
                text-align: left;
                background: #fff;
                -webkit-box-shadow: 0px 1px 12px 0px #f5f5f5;
                box-shadow: 0px 1px 12px 0px #f5f5f5;
                -webkit-transition: background 0.4s ease;
                transition: background 0.4s ease;
                padding: 0.26rem;
                bottom: -0.9rem;
                left: 0.2rem;
                right: 0.2rem;
                position: absolute;
                .tit {
                  font-size: 0.18rem;
                  color: #333333 !important;
                }
                .tit1 {
                  color: #0078d4;
                  margin-top: 0.05rem;
                  height: 0.42rem;
                  overflow: hidden;
                }
                .desc {
                  margin-top: 0.06rem;
                  color: #999999;
                  height: 0.65rem;
                  overflow: hidden;
                  line-height: 0.22rem;
                  word-break: break-all;
                  text-align: justify;
                }
              }
            }
          }
          .swiper-slide:hover {
            .text {
              background: #0078d4;
              .tit,
              .tit1,
              .desc {
                color: #fff !important;
              }
            }
          }
        }
      }
    }
  }
  .box3 {
    .top {
      padding-top: 30px;
    }
    .tip1 {
      font-size: 0.28rem;
      line-height: 1.4;
      padding-top: 0;
    }
    .listbox {
      .detailSection {
        margin-left: 0;
        padding-top: 0;
        .a2 {
          width: 23%;
          margin-left: 0;
          margin-bottom: 0;
          margin-right: 2%;
          margin-top: 20px;
          font-size: 16px;
        }
        .a2:nth-child(4n) {
          margin-right: 0;
        }
        // .a2:nth-child(3n + 3) {
        //   margin-right: 0;
        // }
        // .a2:nth-child(-n + 3) {
        //   margin-top: 0;
        // }
      }
      .morning,
      .afternoon {
        .s1 {
          display: block;
          text-align: center;
          width: 100%;
          color: #333333;
          background: none;
        }
        .a1 {
          padding: 17px 0;
          width: 23%;
          margin-left: 2%;
          font-size: 13px;
        }
      }
    }
    /deep/.ant-form {
      padding-top: 0;
    }
    .tit1 {
      font-size: 0.3rem;
      padding-bottom: 0.1rem;
    }

    #tjjzr {
      // padding: 5px 60px!important;
      // font-size: 0.28rem!important;
      // margin: 0;
      // float: right;
      // margin-top: 0.2rem!important;
      // width: 100%;
      // text-align: center;
      font-size: 12px;
    }
    .confirmBtn {
      margin-top: 0.2rem;
      a {
        width: 100%;
        font-size: 0.28rem;
        padding: 9px 60px;
        i {
          background-size: 0.5rem;
          padding: 0.1rem 0;
          padding-left: 0.55rem;
        }
      }
    }
    .guahao3page1_alert {
      height: fit-content;
      bottom: 0;
      width: 100%;
      margin-left: 0;
      left: 0;
      .close {
        top: 0.1rem;
        right: 0.1rem;
        width: 0.3rem;
        height: 0.3rem;
        background-size: cover;
      }
      .inner {
        padding: 0.3rem;
        .tit2 {
          font-size: 0.4rem;
        }
        .ant-form {
          margin-top: 0.2rem;
          .ant-form-item {
            width: 100%;
            margin-bottom: 0.1rem;
          }
        }

        .guahao3page1-button {
          margin-top: 0.2rem;
          a {
            width: 100%;
            font-size: 0.28rem;
            padding: 0.1rem 0.8rem;
            i {
              background-size: 0.5rem;
              padding: 0.1rem 0;
              padding-left: 0.55rem;
            }
          }
        }
      }
    }
  }
  .box4 {
    padding-top: 20px;
    .boxSuccess {
      .statebox {
        background-size: 1.2rem;
        padding-top: 1.4rem;
        font-size: 0.4rem;
        margin: 0;
        .tit {
          .btn2 {
            width: 4rem;
            margin: 0 auto;
            height: auto;
            line-height: normal;
            padding: 0.2rem 0.4rem;
            right: 0.3rem;
            top: 0.95rem;
            position: static;
            margin-top: 0.2rem;
            span {
              padding-left: 0.5rem;
            }
            span:before {
              width: 0.4rem;
              height: 0.4rem;
              margin-top: -0.18rem;
              background-size: cover;
            }
          }
        }
        .btnSearch {
          margin-top: 30px;
        }
      }
      .box2box {
        .boxitem {
          padding-top: 10px;
          .tit1 {
            font-size: 0.3rem;
            padding-bottom: 0.2rem;
          }
          .textlist {
            padding-top: 0.4rem;
            padding-bottom: 0.2rem;
            .item1 {
              width: 100%;
              margin: 0;
            }
          }
        }
        .boxitem:nth-child(1) {
          padding-top: 30px;
        }
      }
    }
    .boxFail {
      .statebox {
        padding-top: 1.4rem;
        font-size: 0.32rem;
        margin: 0;
        background-size: 1.5rem 1.5rem !important;
        .tit {
          margin-top: 0.5rem;
        }
      }
    }
  }
  .noIdea {
    position: absolute;
    top: -1rem;
    margin: 0rem auto;
    width: 90%;
    height: 500px;
    z-index: 9999;
    background-color: #fff;
    border-radius: 4px;
    padding: 5px 10px 10px;
    .noIdeaClose {
      text-align: right;
      // display: none
    }
    .iframe-box {
      width: 100%;
      height: 460px;
    }
  }
  // .iframe-box {
  //   position: absolute;
  //   top: 0.3rem;
  //   margin: 0.3rem auto;
  //   width: 90%;
  //   height: 80%;
  // }

  .contactfixed {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2002;
    background: #fff;
    padding: 0.4rem 0.4rem 0.3rem;
    text-align: center;
    width: 300px;
    height: 130px;
    h1 {
      font-size: 0.28rem;
      line-height: 0.2rem;
      margin-top: 0.3rem;
    }
    .btn {
      margin-top: 0.5rem;
      a {
        font-size: 0.26rem;
        margin: 0 0.1rem;
        display: inline-block;
        height: 0.55rem;
        line-height: 0.55rem;
        padding: 0 0.5rem;
        min-width: 0.5rem;
        background: #0078c6;
        color: #fff;
        border-radius: 2rem;
      }
    }
  }
}
</style>
